import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import enCreateNote from './locales/createNote/en.json';
import itCreateNote from './locales/createNote/it.json';
import enViewNote from './locales/viewNote/en.json';
import itViewNote from './locales/viewNote/it.json';
import enShareNote from './locales/shareNote/en.json';
import itShareNote from './locales/shareNote/it.json';
import enCommon from './locales/common/en.json';
import itCommon from './locales/common/it.json';
import enFooter from './locales/footer/en.json';
import itFooter from './locales/footer/it.json';
import enPrivacy from './locales/privacy/en.json';
import itPrivacy from './locales/privacy/it.json';
import enSupport from './locales/support/en.json';
import itSupport from './locales/support/it.json';
import enFaq from './locales/faq/en.json';
import itFaq from './locales/faq/it.json';
import enBlocked from './locales/blocked/en.json';
import itBlocked from './locales/blocked/it.json';
import enSecurityCheck from './locales/securityCheck/en.json';
import itSecurityCheck from './locales/securityCheck/it.json';

const resources = {
  en: {
    common: enCommon,
    createNote: enCreateNote,
    viewNote: enViewNote,
    shareNote: enShareNote,
    footer: enFooter,
    privacy: enPrivacy,
    support: enSupport,
    faq: enFaq,
    blocked: enBlocked,
    securityCheck: enSecurityCheck
  },
  it: {
    common: itCommon,
    createNote: itCreateNote,
    viewNote: itViewNote,
    shareNote: itShareNote,
    footer: itFooter,
    privacy: itPrivacy,
    support: itSupport,
    faq: itFaq,
    blocked: itBlocked,
    securityCheck: itSecurityCheck
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'createNote', 'viewNote', 'shareNote', 'footer', 'privacy', 'support', 'faq', 'blocked', 'securityCheck'],
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;